import { Box, styled, Tabs, Typography } from "@mui/material";

export const TemplateTabsStyle = styled(Tabs)`
  .MuiTabs-scrollButtons.Mui-disabled {
    opacity: 0.3;
  }
`;

export const TemplateFormWrapper = styled(Box)`
  margin-top: 3rem;
`;

export const TemplateFormTitle = styled(Typography)`
  margin-bottom: 1rem;
`;

export const TemplateTabLabel = styled(Typography)``;
